module.exports = __webpack_public_path__ + "img/asurion.631111dd.svg";